// extracted by mini-css-extract-plugin
module.exports = {"container":"LogoutButton_container__22gb1"};